module.exports = "<div class=\"home-clients\">\n    <img \n        *ngFor=\"let partner of partners\" \n        routerLink=\"/partners\" \n        src=\"{{partner.iconUrl.url}}\" \n        alt=\"\"\n        class=\"home-clients__logo\"\n    >\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home-clients/home-clients.component.html
// module id = ./src/app/home/home-clients/home-clients.component.html
// module chunks = main